





























import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'RejectAdModal',
})
export default class RejectAdModal extends Vue {
  private rejectReason = '';

  onModalHide(): void {
    this.rejectReason = '';
    this.$emit('hide');
  }

  submit(): void {
    this.$emit('reject', this.rejectReason);
    this.$bvModal.hide('rejectAdModal');
  }
}
